import {useFormContext, useWatch} from "react-hook-form";
import {useTranslation} from "react-i18next";
import React from "react";
import {NFDocumentFooter} from "src/components/Shared/NewForms/NFDocuments/NFDocumentFooter";

export const PurchaseOrderDetailFooter = () => {
    const {t} = useTranslation();
    const {watch} = useFormContext();
    const watchTotalAmount = watch("totalAmount");

    return (
        <>
            <NFDocumentFooter>
                <div className={"d-flex"}>
                    <b>Total amount:{watchTotalAmount}</b>
                </div>
            </NFDocumentFooter>
        </>
    )
}